import { observer } from 'mobx-react-lite';
import { CSSProperties } from 'react';
import { CommonLink } from '@client/component/CommonLink';
import { twMerge } from 'tailwind-merge';

/**
 * 목록 아이템
 * - 두 번째 child 가 늘어남(grow)
 */
const ListItem = observer(
    ({
        link,
        children,
        onClick,
        className,
    }: {
        link?: string;
        children: React.ReactNode;
        onClick?: (e: React.MouseEvent<HTMLElement>) => void;
        className?: string;
    }) => {
        const itemClassName = twMerge(
            'list-row items-center rounded-none py-3 pr-0 pl-0 first:pt-0 last:pb-0',
            className,
        );

        if (link) {
            return (
                <CommonLink
                    to={link}
                    className={itemClassName}
                    preventScrollReset={false}
                    onClick={onClick}
                >
                    {children}
                </CommonLink>
            );
        } else {
            return (
                <div className={itemClassName} onClick={onClick}>
                    {children}
                </div>
            );
        }
    },
);

const ListItemTitle = observer(
    ({ children, className }: { children: React.ReactNode; className?: string }) => {
        return <div className={twMerge('text-base', className)}>{children}</div>;
    },
);

const ListItemSubTitle = observer(
    ({ children, className }: { children: React.ReactNode; className?: string }) => {
        return <div className={twMerge('text-base-content/60 text-xs', className)}>{children}</div>;
    },
);

/**
 * 기본 목록 표시
 */
const List = Object.assign(
    observer(({ children, className }: { children: React.ReactNode; className?: string }) => {
        return (
            <div
                className={twMerge('list text-base', className)}
                style={
                    {
                        // 목록 너비를 최대로 늘림
                        // 목록의 구분선이 이 변수 때문에 작게 보여서 최대로 늘림
                        '--radius-box': '0',
                    } as CSSProperties
                }
            >
                {children}
            </div>
        );
    }),
    {
        Item: ListItem,
        ItemTitle: ListItemTitle,
        ItemSubTitle: ListItemSubTitle,
    },
);

export default List;
